{
  "import.inkind.20230223": "Endret kolonnenavn på dato.",
  "warning.30days": "Obs! Endring i Excel-mal i løpet av de siste 30 dagene!",
  "warning.tips": "Det kan være lurt å laste ned malen på nytt for å ikke få noen konflikter."
}
